import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SiteConfigIF {
    isBottomSheetOpen: boolean;
    isGlobalLoading: boolean;
    overlayStack: string[];
}

const initialState: SiteConfigIF = {
    isBottomSheetOpen: false,
    isGlobalLoading: false,
    overlayStack: [],
};

export const siteConfig = createSlice({
    name: 'siteConfig',
    initialState,
    reducers: {
        setIsBottomSheetOpen: (state, action: PayloadAction<boolean>) => {
            state.isBottomSheetOpen = action.payload;
        },
        setIsGlobalLoading: (state, action: PayloadAction<boolean>) => {
            state.isGlobalLoading = action.payload;
        },
        pushOverlay: (state, action: PayloadAction<string>) => {
            state.overlayStack = state.overlayStack.filter(
                (id) => id !== action.payload,
            );
            state.overlayStack.push(action.payload);
        },
        popOverlay: (state, action: PayloadAction<string>) => {
            state.overlayStack = state.overlayStack.filter(
                (id) => id !== action.payload,
            );
        },
        clearOverlays: (state) => {
            state.overlayStack = [];
        },
    },
});

export const {
    pushOverlay,
    popOverlay,
    clearOverlays,
    setIsBottomSheetOpen,
    setIsGlobalLoading,
} = siteConfig.actions;
